import superagent from 'superagent';
import useLoading from "hooks/useLoading";
import useError from "hooks/useError";
import {BASE_URL as base_url, LOGIN_URL} from "config/const";
import {useHistory} from "react-router";

const useRequest=()=> {
    const loading = useLoading();
    const errorHook = useError();
    const history = useHistory();

    function post(url='', params={}) {
        return new Promise((resolve, reject)=> {
            loading.loadStart();
            superagent.post(`${base_url}${url}`)
                .withCredentials()
                .send({d: params})
                .end((err, res) => {
                    loading.loadEnd();
                    if(!res) {
                        errorHook.showError('リクエストに失敗しました');
                        reject(err);
                    }
                    else {
                        if(res.statusCode !== 200) {
                            // エラーはbodyがnullなのでtextをparseする
                            errorHandler(res);
                            reject(err);
                        }
                        else {
                            resolve(res.body.d);
                        }
                    }
                });
        });
    }
    function upload(url='', file=null, field) {
        return new Promise((resolve, reject)=> {
            loading.loadStart();
            superagent.post(`${base_url}${url}`)
                .withCredentials()
                .attach('file', file)
                .field(field)
                .end((err, res) => {
                    loading.loadEnd();
                    if(!res) {
                        errorHook.showError('リクエストに失敗しました');
                        reject(err);
                    }
                    else {
                        if(res.statusCode !== 200) {
                            // エラーはbodyがnullなのでtextをparseする
                            errorHandler(res);
                            reject(err);
                        }
                        else {
                            resolve(res.body.d);
                        }
                    }
                });
        });
    }
    function login() {
        return new Promise((resolve, reject)=> {
            loading.loadStart();
            superagent.get(LOGIN_URL)
                .withCredentials()
                .end((err, res) => {
                    loading.loadEnd();
                    if(!res) {
                        errorHook.showError('リクエストに失敗しました');
                        reject(err);
                    }
                    else {
                        if(res.statusCode !== 200) {
                            // エラーはbodyがnullなのでtextをparseする
                            errorHandler(res);
                            reject(err);
                        }
                        else {
                            resolve(res.body);
                        }
                    }
                });
        });
    }
    function testlogin() {
        return new Promise((resolve, reject)=> {
            loading.loadStart();
            superagent.get('https://taz-service-ktg72ofidq-an.a.run.app/login')
                .withCredentials()
                .end((err, res) => {
                    loading.loadEnd();
                    if(!res) {
                        errorHook.showError('リクエストに失敗しました');
                        reject(err);
                    }
                    else {
                        if(res.statusCode !== 200) {
                            // エラーはbodyがnullなのでtextをparseする
                            errorHandler(res);
                            reject(err);
                        }
                        else {
                            resolve(res.body);
                        }
                    }
                });
        });
    }

    function errorHandler(res) {
        if(res.text) {
            let error = JSON.parse(res.text);
            if(error.e) {
                error = error.e;
                switch (error.code) {
                    case 1004:
                        history.push(`/login`);
                    break;
                    default:
                        errorHook.showError(error.message);
                    break;
                }
            }
            return;
        }
        errorHook.showError(`リクエストに失敗しました\n${res.statusText}`);
    }

    return {post, upload, login, testlogin};
};

export default useRequest;
